export var EFormInlineSelectDisplayType;
(function (EFormInlineSelectDisplayType) {
    EFormInlineSelectDisplayType["List"] = "list";
    EFormInlineSelectDisplayType["Card"] = "card";
})(EFormInlineSelectDisplayType || (EFormInlineSelectDisplayType = {}));
